<template>
  <div class="recipe-footer-attr col-12-bottom">
    <div class="recipe-footer-attr__row row-noBottom">
      <div
        v-if="cookingTimeText"
        :aria-label="cookingTime + ' att tillaga'"
        class="col recipe-footer-attr__time"
      >
        <span aria-hidden="true">
          <svgicon
            class="recipe-footer-attr__icon"
            name="Time/Time"
          />
          {{ cookingTimeText }}
        </span>
      </div>
      <div
        :aria-label="numberOfIngredients + ' ingredienser'"
        class="col"
      >
        <span aria-hidden="true">
          <svgicon
            class="recipe-footer-attr__icon"
            name="Cooking/Groceries"
          />
          {{ numberOfIngredients }} <span v-if="!hideIngredientsText">Ingredienser</span>
        </span>
      </div>
      <div
        v-if="difficulty"
        :aria-label="difficulty + ' svårighetsgrad'"
        class="col"
      >
        <span aria-hidden="true">
          <svgicon
            class="recipe-footer-attr__icon"
            :name="cookingLevelIcon[difficulty]"
          />
          <span v-if="!hideDifficultyText">{{ difficulty }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import "#/Cooking/Level1"
import "#/Cooking/Level2"
import "#/Cooking/Level3"
import "#/Cooking/Cooking"
import "#/Cooking/Groceries"
import "#/Time/Time"

export default {
  name: "RecipeFooterAttributes",
  props: {
    cookingTime: {
      type: String,
      default: ''
    },
    numberOfIngredients: {
      type: Number,
      default: 0
    },
    difficulty: {
      type: String,
      default: ''
    },
    blockSize: {
      type: String,
      default: 'third'
    }
  },
  data () {
    return {
      cookingLevelIcon: {
        Enkel: 'Cooking/Level1',
        Medel: 'Cooking/Level2',
        Avancerad: 'Cooking/Level3'
      }
    }
  },
  computed: {
    size () {
      return this.isEditable ? "full" : this.blockSize
    },
    isSize () {
      return {
        [this.size]: true
      }
    },
    cookingTimeText () {
      if (this.cookingTime) {
        let time = this.cookingTime.split("minuter").join("min")
        if(this.$root.currentSizeEquals('xs')) {
          time = time.replace('Över', '<')
          time = time.replace('Under', '>')
          return time
        }
        return time
      }
      return ""
    },
    hideIngredientsText () {
      const quarterWithinSize = this.isSize.quarter && this.$root.windowWidth >= 1024
      const lgThird = this.$root.currentSizeEquals('lg') && this.isSize.third
      const xxsSize = this.$root.currentSizeLte('xxs')
      return quarterWithinSize || lgThird || xxsSize
    },
    hideDifficultyText (){
      return this.isSize.quarter && this.$root.windowWidth >= 1024 && this.$root.windowWidth < 1350
    },
  }
}
</script>

<style lang="scss">
  .recipe-footer-attr {
    $attr: &;

    padding: 0 0.5rem 0.5rem 0.5rem !important; // to override .col style

    .recipe-footer-attr__icon {
      fill: $color-green-dark;
      height: 1.25rem;
      width: 1.25rem;
      vertical-align: -5px;
      margin-right: 2px;
    }

    .base-block-epi--full &,
    .base-block-epi--half & {
      @include media-breakpoint-up(lg) {
        @include font(text, 3, "bold");
        #{$attr}__time .svg-icon {
          transform: translateY(-1px);
        }

        line-height: 3.5rem;
      }
    }

    @include font(text, 2, "bold");

    color: $color-green-dark;
    text-align: center;
    width: 100%;

    .recipe-footer-attr__row {
      background: $color-green-lightest;
      margin-left: 0;
      margin-right: 0;
      width: 100%;
      flex-wrap: nowrap;
      line-height: 3rem;

      .base-block-epi--quarter &,
      .base-block-epi--third & {
        @include media-breakpoint-down(sm) {
          line-height: 2rem;
        }
      }

      .base-block-epi--full & {
        @include media-breakpoint-up(md) {
          line-height: 3rem;
        }

        @include media-breakpoint-up(lg) {
          line-height: 5rem;
        }
      }

      .col {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        white-space: nowrap;
      }
    }
  }
</style>
